<template>
  <div>
    <div class="headCon flex-row">
      <p>中介超市详情</p>
      <img
        @click="back"
        class="backIcon"
        src="@/assets/images/mobile/return.png"
        alt=""
      />
    </div>
    <div class="flex-row subCon">
      <div class="divider"></div>
      <span class="subTitle">中介机构详情</span>
    </div>
    <div class="listCon">
      <el-row class="rowList flex-row">
        <span>机构名称：{{ detailData.agencyname }}</span>
      </el-row>
      <el-row class="rowList flex-row">
        <span>统一社会信用代码：{{ detailData.creditcode }}</span>
      </el-row>
      <el-row class="rowList flex-row">
        <el-col :span="11">
          <span>注册时间：{{ detailData.registedate }}</span>
        </el-col>
        <el-col :span="13">
          <span>用户类型：{{ detailData.usertype }}</span>
        </el-col>
      </el-row>
      <el-row class="rowList flex-row">
        <el-col :span="11">
          <span>法定代表人：{{ detailData.legal }}</span>
        </el-col>
        <el-col :span="13">
          <span>法人手机：{{ detailData.legal_mobile }}</span>
        </el-col>
      </el-row>
      <el-row class="rowList flex-row">
        <el-col :span="11">
          <span>联系人：{{ detailData.contact_person }}</span>
        </el-col>
        <el-col :span="13">
          <span>联系人手机：{{ detailData.contact_tel }}</span>
        </el-col>
      </el-row>
      <el-row class="rowList rowList2">
        <div class="listName">注册地址：</div>
        <div class="listContent">
          {{ detailData.registered_address }}
        </div>
      </el-row>
      <el-row class="rowList rowList2">
        <div class="listName">办公地址：</div>
        <div class="listContent">
          {{ detailData.office_address }}
        </div>
      </el-row>
      <el-row class="rowList rowList2">
        <div class="listName">经营范围：</div>
        <div class="listContent">
          {{ detailData.jyfw }}
        </div>
      </el-row>
      <el-row class="rowList rowList2">
        <div class="listName">单位简介：</div>
        <div class="listContent">
          {{ detailData.dept_info }}
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      agencyid: "", //介唯一标识
      agencyguid: "", //中介标识
      detailData: {},
    };
  },
  created() {
    let data = JSON.parse(sessionStorage.getItem("policyData"));
    this.agencyid = data.agencyid;
    this.agencyguid = data.agencyguid || "";
    this.getMarketDetail();
  },
  mounted() {},
  methods: {
    back() {
      this.$router.push("/intermediaryMarket");
    },
    getMarketDetail() {
      let url = "/dev-api/superMakert/zjcsDetail";
      let params = {
        agencyid: this.agencyid,
      };
      if (this.agencyguid) {
        params["agencyguid"] = this.agencyguid;
      }
      this.$httpApi
        .post(url, params)
        .then((res) => {
          this.detailData = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang='scss' scoped>
.headCon {
  width: 100%;
  height: 6.25rem;
  background: #36ab60;
  position: relative;
  p {
    width: 100%;
    font-size: 1.375rem;
    color: #fff;
    text-align: center;
    letter-spacing: 0.5rem;
  }
  .backIcon {
    width: 1.875rem;
    position: absolute;
    top: 2.375rem;
    left: 1.25rem;
  }
}
.subCon {
  margin-top: 20px;
  margin-bottom: 30px;
  .divider {
    width: 15px;
    height: 30px;
    background: #36ab60;
    margin: 0 10px;
  }
  .subTitle {
    font-size: 20px;
    font-weight: 600;
    color: #000;
  }
}
.listCon {
  width: 100vw;
  min-height: 80vh;
  .rowList {
    width: 100%;
    min-height: 50px;
    border-bottom: 2px solid #e2e2e2;
    padding: 15px;
    .listName {
      width: 170px;
    }
    .listContent {
      width: 500px;
    }
  }
  .rowList2 {
    display: flex;
    justify-content: space-between;
  }
}
</style>
